import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditIconOutlined from "@material-ui/icons/CreateOutlined";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import PerfectScrollbar from "react-perfect-scrollbar";
import { toast } from "react-toastify";
import {
  addNewCategory,
  createCategoryModalClosed,
  createCategoryModalOpened,
  getAllCategoryList,
  getCategorySuccess,
  getCategoryListData,
  getCategoryModalOpen,
  getSelectedCategoryObject,
  categoryObjectNull,
  updateSingleCategoryObject,
  getDeleteCategory,
  getCreateFlag,
} from "../store/categoryManagement";

const CategoryManagement = () => {
  return <CategoryManagementPane></CategoryManagementPane>;
};

const CategoryManagementPane = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCategoryList());
  }, [dispatch]);

  const categoryListData = useSelector(getCategoryListData);

  const onNewCategoryModelChangeHandle = () => {
    dispatch(categoryObjectNull());
    dispatch(createCategoryModalOpened());
  };

  const onUpdateCategoryModelChangeHandle = (category) => {
    dispatch(updateSingleCategoryObject(category));
    dispatch(createCategoryModalOpened());
  };

  return (
    <div className="m-4">
      <div className="d-flex">
        <div className="m-4" style={{ width: "100%" }}>
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            You can add, suspend and update category details
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">Category Title</th>
                  <th scope="col">Category Code</th>
                  <th scope="col">Action Button</th>
                </tr>
              </thead>
              <tbody>
                {categoryListData &&
                  categoryListData.map((category, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {category?.title?.en}
                          {category?.title?.fr && ` / ${category?.title?.fr}`}
                        </td>
                        <td>{category?.code}</td>
                        <td className="d-flex">
                          <div
                            className="text-center"
                            style={{
                              backgroundColor: theme.COLORS.dark_green_dot,
                              width: "40px",
                              padding: 5,
                              borderRadius: 20,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <EditIconOutlined
                              text="Update"
                              onClick={() =>
                                onUpdateCategoryModelChangeHandle(category)
                              }
                            />
                          </div>
                          <div
                            className="text-center bg-danger"
                            style={{
                              width: "40px",
                              padding: 5,
                              borderRadius: 20,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <DeleteOutlineOutlinedIcon
                              onClick={() => {
                                const id = [category._id];
                                dispatch(getDeleteCategory({ _ids: id })).then(
                                  () => {
                                    dispatch(getAllCategoryList());
                                    setTimeout(() => {
                                      toast.success("Category deleted");
                                    }, 200);
                                  }
                                );
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_orange,
                border: 0,
                width: "10vw",
              }}
              onClick={onNewCategoryModelChangeHandle}
            >
              Add Category
            </Button>
          </div>
        </div>
      </div>
      <CategoryModal></CategoryModal>
    </div>
  );
};

const CategoryModal = () => {
  const newCategoryModalState = useSelector(getCategoryModalOpen);
  return (
    <Modal
      size="md"
      isOpen={newCategoryModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "22rem",
          width: "40rem",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <CategoryModalPage></CategoryModalPage>
    </Modal>
  );
};

const CategoryModalPage = () => {
  const dispatch = useDispatch();
  const catSuccess = useSelector(getCategorySuccess);
  const updateCategoryData = useSelector(getSelectedCategoryObject);
  const [categoryTitle, setCategoryTitle] = useState("");
  const [categoryTitleFr, setCategoryTitleFr] = useState("");
  const [categoryCode, setCategoryCode] = useState("");
  const [titleError, setTitleError] = useState("");
  const [codeError, setCodeError] = useState("");

  useEffect(() => {
    // If updating, initialize the form with existing data.
    if (updateCategoryData?._id) {
      setCategoryTitle(
        updateCategoryData?.title?.en || updateCategoryData?.title || ""
      );
      setCategoryTitleFr(updateCategoryData?.title?.fr || "");
      setCategoryCode(updateCategoryData?.code || "");
    }
  }, [updateCategoryData]);

  const onAddButtonClick = async () => {
    // Validate required fields: English title and code.
    if (!categoryTitle.trim() || !categoryCode.trim()) {
      if (!categoryTitle.trim()) setTitleError("English title is required");
      if (!categoryCode.trim()) setCodeError("Category code is required");
      return;
    }

    const categoryData = {
      title: {
        en: categoryTitle,
        fr: categoryTitleFr, // optional French title
      },
      code: categoryCode,
    };

    // For updates, include _id.
    if (updateCategoryData?._id) {
      categoryData._id = updateCategoryData._id;
    }

    await dispatch(addNewCategory(categoryData)).then(() => {
      setTimeout(() => {
        toast.success(catSuccess?.message);
        dispatch(createCategoryModalClosed());
        dispatch(getAllCategoryList());
      }, 400);
    });
  };

  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "24px" }}
          >
            {updateCategoryData?._id
              ? "Update a category"
              : "Add a new category"}
          </div>
          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(categoryObjectNull());
                dispatch(createCategoryModalClosed());
              }}
            />
          </div>
        </div>
        <div
          className="row pt-3 justify-content-center"
          style={{ fontFamily: "GibsonRegular" }}
        >
          <div className="col-10">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">English Title</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    id="uTitle"
                    name="uTitle"
                    className="form-control"
                    placeholder="Enter English Title"
                    required
                    style={{ backgroundColor: "#fff" }}
                    onChange={(event) => {
                      setTitleError("");
                      setCategoryTitle(event.target.value);
                    }}
                    value={categoryTitle}
                  />
                  {titleError && <p style={{ color: "red" }}>{titleError}</p>}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  French Title (optional)
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    id="uTitleFr"
                    name="uTitleFr"
                    className="form-control"
                    placeholder="Enter French Title"
                    style={{ backgroundColor: "#fff" }}
                    onChange={(event) => {
                      setCategoryTitleFr(event.target.value);
                    }}
                    value={categoryTitleFr}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Code</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    id="code"
                    name="code"
                    className="form-control"
                    placeholder="Enter Code"
                    required
                    disabled={!!updateCategoryData?._id}
                    style={{ backgroundColor: "#fff" }}
                    onChange={(event) => {
                      setCodeError("");
                      setCategoryCode(event.target.value);
                    }}
                    value={categoryCode}
                  />
                  {codeError && <p style={{ color: "red" }}>{codeError}</p>}
                </div>
              </div>
              <div
                className="form-group row justify-content-center"
                style={{ paddingTop: "2%" }}
              >
                <div className="col-12">
                  <button
                    type="button"
                    style={{
                      backgroundColor: theme.COLORS.secondary_orange,
                      borderRadius: "10px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={onAddButtonClick}
                  >
                    {updateCategoryData?._id
                      ? "Update Category"
                      : "Add a new category"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

export default CategoryManagement;
